import VusIcon from './vus-icon.vue';
export default VusIcon;



// WEBPACK FOOTER //
// ./src/components/vus-icon/index.js